export const getCookie = (name:any) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

export function getAPIBASEURL(): string {
  const baseURL = import.meta.env.VITE_SKILLZEN_BASE_URL;

  if (typeof window === "undefined" || typeof location === "undefined") {
    return baseURL;
  }

  const { hostname } = location;

  if (hostname.includes("localhost")) {
    return baseURL;
  }

  const parts = hostname.split(".");
  if (parts.length >= 3) {
    const subdomain = parts[0];

    if (subdomain === "learner") {
      return baseURL;
    }

    if (subdomain.endsWith("-learner")) {
      const brand = subdomain.replace("-learner", "");
      if (brand === "dev") {
        return baseURL;
      }
      return `https://${brand}-api.skillzen.ai`;
    }

    return `https://${subdomain}-api.skillzen.ai`;
  }

  return baseURL;
}

export const getBaseUrl = () => {
  try {
    const url = window.location.href;
    const urlObject = new URL(url);
    return `${urlObject.protocol}//${urlObject.hostname}`;
  } catch (e) {
    console.error(`Error in getting the baseURL.`, e);
  }
};
export const setCookie = (
  name: string,
  value: string,
  days: number = 1,
  options: { session?: boolean } = { session: true },
) => {
  let expires = "";

  if (!options.session) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `expires=${date.toUTCString()};`;
  }

  document.cookie = `${name}=${value}; ${expires}path=/`;
};

export const validateFolderName = (value: string) => {
  return /^[A-Za-z0-9\s]*$/.test(value);
};